import React from 'react';
import {Link} from 'react-router-dom';
import {GetTextColor} from "../../../ColorFunctions";

export const MenuHeader = ({ title, logo, style }) => {

    return (
        <header>
            <div className="navbar navbar-expand-sm navbar-toggleable-sm ng-white" style={{ position: "absolute", left: 0, right: 0, ...style }}>
                <div className={'container'} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ paddingTop: '.8rem',display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                        {
                            logo ?
                                <img src={logo} width={60} height={60} style={{ borderRadius: '50%' }} />
                                :
                                null
                        }
                        <span
                            style={{
                                fontSize: '1.4rem',
                                padding: 0,
                                textAlign: 'center',
                                paddingTop: ".2rem",
                                color: GetTextColor(style.backgroundColor),
                        }}>
                            {title}
                        </span>
                    </div>
                </div>
            </div>
        </header>
    );
}